const initialstate ={
  data:[],
  dashdata:[],
  pieChartData: {},
  fundmanagerChartData: {},
  mobChartData: {},
  piechartOptions: {},
  mobChart: {},
  fundpieChartData:{},
  fundpiechartOptions:{},
  funChartData:{},
  funchartOptions:{},
  fundChart:{},
  donpieChartData: {},
  managerChartData: {},
  donorChartData: {},
  donpiechartOptions: {},
  donorChart: {},
}

const MobDashboardReducers = (state = initialstate, action: any) => {
  switch (action.type) {
      case 'FETCH_DATA_SUCCESS':
        return { ...state, data: action.payload };
        case 'FETCH_DASH_DATA_SUCCESS':
        return { ...state, dashdata: action.payload };
    case 'FETCH_PIE_CHART_DATA_SUCCESS':
      return {...state,pieChartData: action.payload.pieChartData,piechartOptions: action.payload.piechartOptions};
      case 'FETCH_ORGANISATION_CHART_DATA_SUCCESS':
          return {...state,mobChartData: action.payload.mobChartData,mobChart: action.payload.mobchartOptions};
          case 'FETCH_FUND_CHART_DATA_SUCCESS':
      return {...state,fundpieChartData: action.payload.fundpieChartData,fundpiechartOptions: action.payload.fundpiechartOptions};
    case 'FETCH_FUN_BAR_DATA_SUCCESS':
      return {...state,funChartData: action.payload.funChartData,fundChart: action.payload.funchartOptions};
      case 'FETCH_DONOR_PIE_CHART_DATA_SUCCESS':
      return {...state,donpieChartData: action.payload.donpieChartData,donpiechartOptions: action.payload.donpiechartOptions};
    case 'FETCH_Donor_CHART_DATA_SUCCESS':
      return {...state,donorChartData: action.payload.donorChartData,donorChart: action.payload.donorrchartOptions};
      
    default:
          return state;
  }
};
export default MobDashboardReducers;